// Client-side functionality
document.addEventListener('DOMContentLoaded', () => {
  // Handle name updates
  const firstNameInput = document.getElementById('client_first_name')
  const lastNameInput = document.getElementById('client_last_name')
  const nameHeader = document.querySelector('h1.name')

  const updateName = () => {
    if (nameHeader) {
      nameHeader.textContent = `${firstNameInput.value} ${lastNameInput.value}`
    }
  }

  if (firstNameInput && lastNameInput) {
    firstNameInput.addEventListener('input', updateName)
    lastNameInput.addEventListener('input', updateName)
  }
}) 